import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppRouteGuard } from '@shared/auth/auth-route-guard';

const routes: Routes = [
    { path: '', redirectTo: '/web/home', pathMatch: 'full' },
    // {
    //     path: 'account',
    //     loadChildren: () => import('account/account.module').then((m) => m.AccountModule), // Lazy load account module
    //     data: { preload: true },
    // },
    {
        path: 'app',
        loadChildren: () => import('app/app.module').then((m) => m.AppModule), // Lazy load account module
        data: { preload: true, permission: 'Pages.Administration' },
        canActivate: [AppRouteGuard],
    },
    {
        path: 'web',
        loadChildren: () => import('web/web.module').then((m) => m.WebModule), // Lazy load account module
        data: { preload: true },
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'top',
            anchorScrolling: 'enabled',
        }),
    ],
    exports: [RouterModule],
    providers: [],
})
export class RootRoutingModule {}
